var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAbout = function SvgAbout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.205 7.416c0 .137 0 .275-.01.403a4.15 4.15 0 0 0-4.152.788 4.06 4.06 0 0 0-2.731-1.044c-2.255 0-4.089 1.842-4.089 4.115 0 2.595 1.302 4.492 2.549 5.72a.967.967 0 0 1-.257-.055c-2.374-.816-7.682-4.189-7.682-9.927 0-2.53 2.035-4.574 4.547-4.574 1.494 0 2.814.715 3.64 1.824a4.544 4.544 0 0 1 3.638-1.824c2.512 0 4.547 2.044 4.547 4.574Z",
    fill: "#BF0637"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.79c-.98 0-1.87.478-2.42 1.21a3.02 3.02 0 0 0-2.42-1.21 3.032 3.032 0 0 0-3.025 3.044c0 .651.1 1.247.284 1.797.862 2.722 3.511 4.345 4.822 4.794.183.064.486.064.678 0 1.311-.45 3.96-2.072 4.822-4.794.183-.56.284-1.155.284-1.797A3.032 3.032 0 0 0 16.5 8.791Z",
    fill: "#BF0637"
  })));
};
export default SvgAbout;